module.exports = __webpack_public_path__ + "img/shoppingCart_g.9c0d1cff.svg";